if (!customElements.get('new-slideshow')) {
  class NewSlideshow extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector('.new-slideshow__wrapper');
      this.slides = this.querySelectorAll('.new-slideshow__slide');
      this.dots = this.querySelectorAll('.new-slideshow__dot');
      this.prevBtn = this.querySelector('.new-slideshow__arrow--prev');
      this.nextBtn = this.querySelector('.new-slideshow__arrow--next');
      this.currentIndex = 0;
      
      if (this.slides.length <= 1) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed) || 5000;

      this.bindEvents();
      if (this.autoplay) this.startAutoplay();
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
      
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });

      // Touch swipe events
      let startX = 0;
      let endX = 0;
      this.addEventListener('touchstart', e => {
        startX = e.changedTouches[0].screenX;
      }, {passive: true});

      this.addEventListener('touchend', e => {
        endX = e.changedTouches[0].screenX;
        this.handleSwipe(startX, endX);
      }, {passive: true});
    }

    handleSwipe(start, end) {
      if (start - end > 50) this.next();
      if (end - start > 50) this.prev();
    }

    goToSlide(index) {
      this.currentIndex = index;
      if (this.currentIndex >= this.slides.length) this.currentIndex = 0;
      if (this.currentIndex < 0) this.currentIndex = this.slides.length - 1;

      this.wrapper.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      
      this.dots.forEach(dot => dot.classList.remove('is-active'));
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('is-active');
      }
    }

    next() {
      this.goToSlide(this.currentIndex + 1);
    }

    prev() {
      this.goToSlide(this.currentIndex - 1);
    }

    startAutoplay() {
      this.pauseAutoplay();
      this.autoplayInterval = setInterval(() => this.next(), this.speed);
    }

    pauseAutoplay() {
      if (this.autoplayInterval) clearInterval(this.autoplayInterval);
    }
  }
  customElements.define('new-slideshow', NewSlideshow);
}